import { metrics } from '@atlassian/browser-metrics';

export const clickEditSprintInteraction = metrics.interaction({
	key: 'sprint-edit-click',
});

export const editSprintModalLoad = metrics.interaction({
	key: 'edit-sprint-modal-load',
});
